import { render, staticRenderFns } from "./ManageAgreements.vue?vue&type=template&id=56c96470&scoped=true&"
import script from "./ManageAgreements.vue?vue&type=script&lang=js&"
export * from "./ManageAgreements.vue?vue&type=script&lang=js&"
import style0 from "./ManageAgreements.vue?vue&type=style&index=0&id=56c96470&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56c96470",
  null
  
)

export default component.exports